/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {NoHeaderStreamBankImmutableList} from "../../Extensions/Core/ListOverrides";
import {StreamBankAutoCompleteItem} from "../../../Components/Common/StreamBankAutoCompleteItem";

export const CommaSeparatedImmutableListViewer = props => {

    const {separator = ',', Value: value} = props;
    const data = value.split(separator).map(x => x?.trim() ?? x);
    
    return <NoHeaderStreamBankImmutableList
            Type={StreamBankAutoCompleteItem}
            GetItemKey={(x, i) => i}
            Data={data}
            GetTitle={(x) => x}
        />;
};